import { useEffect, useState } from 'react';

import {
  STREAMLAIN_PHONE_QUERY,
  STREAMLAIN_TWO_PANE_OVERLAY_QUERY,
} from '../../modules/streamlain/shared/workspace-pane-layout';

export const MOBILE_NAVIGATION_RAIL_QUERY = STREAMLAIN_PHONE_QUERY;
export const TABLET_NAVIGATION_RAIL_QUERY = '(max-width: 900px)';
export const TWO_PANE_OVERLAY_QUERY = STREAMLAIN_TWO_PANE_OVERLAY_QUERY;

const matchesNavigationRailViewport = (query: string) =>
  typeof window !== 'undefined' && window.matchMedia(query).matches;

export const useNavigationRailViewport = (query: string) => {
  const [matches, setMatches] = useState(() =>
    matchesNavigationRailViewport(query)
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const update = () => setMatches(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, [query]);

  return matches;
};
